import React from 'react';
import AdminRouteGuard from '../../components/guards/AdminRouteGuard';
import UserStatusCheckPage from './UserStatusCheckPage';

const UserStatusCheckPageWrapper: React.FC = () => {
  return (
    <AdminRouteGuard>
      <UserStatusCheckPage />
    </AdminRouteGuard>
  );
};

export default UserStatusCheckPageWrapper;